import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "fixed inset-0 z-50 overflow-y-auto flex items-center justify-center"
}
const _hoisted_2 = { class: "flex items-center justify-center min-h-screen pt-4 px-4 pb-20 text-center" }
const _hoisted_3 = {
  class: "bg-white rounded-lg text-left overflow-hidden shadow-xl transform transition-all sm:my-8 sm:max-w-5xl sm:w-full max-h-[90vh] flex flex-col",
  style: {"min-width":"1000px"}
}
const _hoisted_4 = { class: "bg-white px-4 pt-5 pb-4 sm:p-6 sm:pb-4 overflow-y-auto" }
const _hoisted_5 = { class: "flex justify-between items-start" }
const _hoisted_6 = { class: "mt-4 bg-white border border-gray-200 rounded-lg shadow-sm p-4" }
const _hoisted_7 = { class: "grid grid-cols-2 gap-4 mb-4" }
const _hoisted_8 = { class: "flex items-center mt-1" }
const _hoisted_9 = {
  key: 0,
  class: "flex-shrink-0 h-6 w-6"
}
const _hoisted_10 = ["src"]
const _hoisted_11 = {
  key: 1,
  class: "flex-shrink-0 h-6 w-6 rounded-full bg-blue-100 flex items-center justify-center text-xs font-medium text-blue-800"
}
const _hoisted_12 = { class: "ml-2 text-sm text-gray-900" }
const _hoisted_13 = { class: "mt-1 text-sm text-gray-900" }
const _hoisted_14 = { class: "mt-1 text-sm text-gray-900" }
const _hoisted_15 = {
  key: 0,
  class: "mt-6 flex items-center justify-center",
  style: {"height":"500px"}
}
const _hoisted_16 = {
  key: 1,
  class: "mt-6 flex items-center justify-center",
  style: {"height":"500px"}
}
const _hoisted_17 = { class: "text-red-500 flex flex-col items-center" }
const _hoisted_18 = {
  key: 2,
  class: "mt-6 flex items-center justify-center absolute inset-0 bg-white bg-opacity-75 z-10"
}
const _hoisted_19 = {
  key: 3,
  class: "relative"
}
const _hoisted_20 = { class: "mt-4 flex space-x-2 p-1" }
const _hoisted_21 = ["disabled"]
const _hoisted_22 = { style: {"height":"500px"} }
const _hoisted_23 = {
  key: 0,
  class: "mt-4 p-3 bg-green-100 border border-green-300 rounded-md text-green-700 flex items-center"
}
const _hoisted_24 = {
  key: 1,
  class: "mt-4 p-3 bg-red-100 border border-red-300 rounded-md text-red-700 flex items-center"
}
const _hoisted_25 = { class: "bg-gray-50 px-4 py-3 sm:px-6 flex justify-end sticky bottom-0" }
const _hoisted_26 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ExcelViewer = _resolveComponent("ExcelViewer")!

  return (_ctx.isOpen)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", {
            class: "fixed inset-0 transition-opacity",
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.close && _ctx.close(...args)))
          }, _cache[8] || (_cache[8] = [
            _createElementVNode("div", { class: "absolute inset-0 bg-gray-500 opacity-75" }, null, -1)
          ])),
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, [
                _cache[10] || (_cache[10] = _createElementVNode("div", null, [
                  _createElementVNode("h3", { class: "text-xl font-bold text-gray-900" }, " Review Forecasting Template "),
                  _createElementVNode("p", { class: "text-sm text-gray-500 mt-1" }, "Review and edit the forecast template")
                ], -1)),
                _createElementVNode("button", {
                  onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.close && _ctx.close(...args))),
                  class: "text-gray-400 hover:text-gray-500"
                }, _cache[9] || (_cache[9] = [
                  _createElementVNode("svg", {
                    class: "h-6 w-6",
                    fill: "none",
                    viewBox: "0 0 24 24",
                    stroke: "currentColor"
                  }, [
                    _createElementVNode("path", {
                      "stroke-linecap": "round",
                      "stroke-linejoin": "round",
                      "stroke-width": "2",
                      d: "M6 18L18 6M6 6l12 12"
                    })
                  ], -1)
                ]))
              ]),
              _createElementVNode("div", _hoisted_6, [
                _createElementVNode("div", _hoisted_7, [
                  _createElementVNode("div", null, [
                    _cache[11] || (_cache[11] = _createElementVNode("h4", { class: "text-sm font-medium text-gray-700" }, "Assignee", -1)),
                    _createElementVNode("div", _hoisted_8, [
                      (_ctx.documentData.created_by_avatar_url)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                            _createElementVNode("img", {
                              src: _ctx.documentData.created_by_avatar_url,
                              alt: "Avatar",
                              class: "h-6 w-6 rounded-full object-cover"
                            }, null, 8, _hoisted_10)
                          ]))
                        : (_openBlock(), _createElementBlock("div", _hoisted_11, _toDisplayString(_ctx.documentData.created_by_name ? _ctx.documentData.created_by_name.charAt(0) : 'U'), 1)),
                      _createElementVNode("span", _hoisted_12, _toDisplayString(_ctx.documentData.created_by_name || 'Andrej Svetina'), 1)
                    ])
                  ]),
                  _createElementVNode("div", null, [
                    _cache[12] || (_cache[12] = _createElementVNode("h4", { class: "text-sm font-medium text-gray-700" }, "Due Date", -1)),
                    _createElementVNode("p", _hoisted_13, _toDisplayString(_ctx.documentData.due_date ? _ctx.formatDate(new Date(_ctx.documentData.due_date)) : '17/11/2025'), 1)
                  ])
                ]),
                _createElementVNode("div", null, [
                  _cache[13] || (_cache[13] = _createElementVNode("h4", { class: "text-sm font-medium text-gray-700" }, "Description", -1)),
                  _createElementVNode("p", _hoisted_14, _toDisplayString(_ctx.documentData.description || 'Q2 2025 marketing budget report for financial planning.'), 1)
                ])
              ]),
              (_ctx.isFileLoading)
                ? (_openBlock(), _createElementBlock("div", _hoisted_15, _cache[14] || (_cache[14] = [
                    _createElementVNode("div", { class: "text-gray-500 flex flex-col items-center" }, [
                      _createElementVNode("svg", {
                        class: "animate-spin h-10 w-10 text-primary mb-4",
                        xmlns: "http://www.w3.org/2000/svg",
                        fill: "none",
                        viewBox: "0 0 24 24"
                      }, [
                        _createElementVNode("circle", {
                          class: "opacity-25",
                          cx: "12",
                          cy: "12",
                          r: "10",
                          stroke: "currentColor",
                          "stroke-width": "4"
                        }),
                        _createElementVNode("path", {
                          class: "opacity-75",
                          fill: "currentColor",
                          d: "M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                        })
                      ]),
                      _createElementVNode("p", null, "Loading spreadsheet data...")
                    ], -1)
                  ])))
                : (_ctx.fileError)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                      _createElementVNode("div", _hoisted_17, [
                        _cache[15] || (_cache[15] = _createElementVNode("svg", {
                          class: "h-10 w-10 text-red-500 mb-4",
                          fill: "none",
                          stroke: "currentColor",
                          viewBox: "0 0 24 24",
                          xmlns: "http://www.w3.org/2000/svg"
                        }, [
                          _createElementVNode("path", {
                            "stroke-linecap": "round",
                            "stroke-linejoin": "round",
                            "stroke-width": "2",
                            d: "M12 8v4m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
                          })
                        ], -1)),
                        _createElementVNode("p", null, _toDisplayString(_ctx.fileError), 1),
                        _createElementVNode("button", {
                          onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.retryFileLoad && _ctx.retryFileLoad(...args))),
                          class: "mt-4 px-4 py-2 bg-blue-600 text-white rounded hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-500"
                        }, " Retry ")
                      ])
                    ]))
                  : (_ctx.isSaving)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_18, _cache[16] || (_cache[16] = [
                        _createElementVNode("div", { class: "text-gray-800 flex flex-col items-center" }, [
                          _createElementVNode("svg", {
                            class: "animate-spin h-10 w-10 text-primary mb-4",
                            xmlns: "http://www.w3.org/2000/svg",
                            fill: "none",
                            viewBox: "0 0 24 24"
                          }, [
                            _createElementVNode("circle", {
                              class: "opacity-25",
                              cx: "12",
                              cy: "12",
                              r: "10",
                              stroke: "currentColor",
                              "stroke-width": "4"
                            }),
                            _createElementVNode("path", {
                              class: "opacity-75",
                              fill: "currentColor",
                              d: "M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                            })
                          ]),
                          _createElementVNode("p", null, "Saving changes...")
                        ], -1)
                      ])))
                    : (_openBlock(), _createElementBlock("div", _hoisted_19, [
                        _createElementVNode("div", _hoisted_20, [
                          _createElementVNode("button", {
                            onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.exportToExcel && _ctx.exportToExcel(...args))),
                            class: "inline-flex items-center px-3 py-1.5 border border-gray-300 text-sm font-medium rounded-md text-gray-700 bg-white hover:bg-gray-50"
                          }, _cache[17] || (_cache[17] = [
                            _createElementVNode("svg", {
                              class: "h-4 w-4 mr-1.5",
                              fill: "none",
                              stroke: "currentColor",
                              viewBox: "0 0 24 24",
                              xmlns: "http://www.w3.org/2000/svg"
                            }, [
                              _createElementVNode("path", {
                                "stroke-linecap": "round",
                                "stroke-linejoin": "round",
                                "stroke-width": "2",
                                d: "M4 16v1a3 3 0 003 3h10a3 3 0 003-3v-1m-4-4l-4 4m0 0l-4-4m4 4V4"
                              })
                            ], -1),
                            _createTextVNode(" Export Excel ")
                          ])),
                          _createElementVNode("button", {
                            onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.exportToCsv && _ctx.exportToCsv(...args))),
                            class: "inline-flex items-center px-3 py-1.5 border border-gray-300 text-sm font-medium rounded-md text-gray-700 bg-white hover:bg-gray-50"
                          }, _cache[18] || (_cache[18] = [
                            _createElementVNode("svg", {
                              class: "h-4 w-4 mr-1.5",
                              fill: "none",
                              stroke: "currentColor",
                              viewBox: "0 0 24 24",
                              xmlns: "http://www.w3.org/2000/svg"
                            }, [
                              _createElementVNode("path", {
                                "stroke-linecap": "round",
                                "stroke-linejoin": "round",
                                "stroke-width": "2",
                                d: "M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"
                              })
                            ], -1),
                            _createTextVNode(" Export CSV ")
                          ])),
                          _createElementVNode("button", {
                            onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.saveChangesToDb && _ctx.saveChangesToDb(...args))),
                            class: "inline-flex items-center px-3 py-1.5 border border-primary text-sm font-medium rounded-md text-primary bg-white hover:bg-blue-50",
                            disabled: _ctx.isSaving
                          }, _cache[19] || (_cache[19] = [
                            _createElementVNode("svg", {
                              class: "h-4 w-4 mr-1.5",
                              fill: "none",
                              stroke: "currentColor",
                              viewBox: "0 0 24 24",
                              xmlns: "http://www.w3.org/2000/svg"
                            }, [
                              _createElementVNode("path", {
                                "stroke-linecap": "round",
                                "stroke-linejoin": "round",
                                "stroke-width": "2",
                                d: "M8 7H5a2 2 0 00-2 2v9a2 2 0 002 2h14a2 2 0 002-2V9a2 2 0 00-2-2h-3m-1 4l-3 3m0 0l-3-3m3 3V4"
                              })
                            ], -1),
                            _createTextVNode(" Save Changes ")
                          ]), 8, _hoisted_21)
                        ]),
                        _createElementVNode("div", _hoisted_22, [
                          _createVNode(_component_ExcelViewer, {
                            ref: "excelViewerComponent",
                            fileData: _ctx.excelFileData || undefined,
                            readOnly: false
                          }, null, 8, ["fileData"])
                        ]),
                        (_ctx.saveSuccess)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_23, [
                              _cache[20] || (_cache[20] = _createElementVNode("svg", {
                                class: "h-5 w-5 mr-2",
                                fill: "none",
                                stroke: "currentColor",
                                viewBox: "0 0 24 24",
                                xmlns: "http://www.w3.org/2000/svg"
                              }, [
                                _createElementVNode("path", {
                                  "stroke-linecap": "round",
                                  "stroke-linejoin": "round",
                                  "stroke-width": "2",
                                  d: "M5 13l4 4L19 7"
                                })
                              ], -1)),
                              _createElementVNode("span", null, _toDisplayString(_ctx.saveSuccess), 1)
                            ]))
                          : _createCommentVNode("", true),
                        (_ctx.saveError)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_24, [
                              _cache[21] || (_cache[21] = _createElementVNode("svg", {
                                class: "h-5 w-5 mr-2",
                                fill: "none",
                                stroke: "currentColor",
                                viewBox: "0 0 24 24",
                                xmlns: "http://www.w3.org/2000/svg"
                              }, [
                                _createElementVNode("path", {
                                  "stroke-linecap": "round",
                                  "stroke-linejoin": "round",
                                  "stroke-width": "2",
                                  d: "M12 8v4m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
                                })
                              ], -1)),
                              _createElementVNode("span", null, _toDisplayString(_ctx.saveError), 1)
                            ]))
                          : _createCommentVNode("", true)
                      ]))
            ]),
            _createElementVNode("div", _hoisted_25, [
              _createElementVNode("button", {
                onClick: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.close && _ctx.close(...args))),
                class: "mr-2 inline-flex justify-center rounded-md border border-gray-300 shadow-sm px-4 py-2 bg-white text-base font-medium text-gray-700 hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 sm:text-sm"
              }, " Cancel "),
              _createElementVNode("button", {
                onClick: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.saveAndClose && _ctx.saveAndClose(...args))),
                class: "inline-flex justify-center rounded-md border border-transparent shadow-sm px-4 py-2 bg-blue-600 text-base font-medium text-white hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 sm:text-sm",
                disabled: !!_ctx.isFileLoading || !!_ctx.fileError || !!_ctx.isSaving
              }, " Approve Template ", 8, _hoisted_26)
            ])
          ])
        ])
      ]))
    : _createCommentVNode("", true)
}